/**
 * @fileoverview GET handler for the "/integrations/get_technology_partner_data/:pill/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import type { IntegrationsGetTechnologyPartnersDataResult } from "../integrationsGetTechnologyPartnersData/types";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsGetTechnologyPartnerData } from "./constants";

export const getIntegrationsGetTechnologyPartnerData = reactQueryFetcherAdapter(
  integrationsGetTechnologyPartnerData,
  (
    signal: AbortSignal,
    partnerId: string,
    appGroupId: string
  ): Promise<IntegrationsGetTechnologyPartnersDataResult> => {
    return fetch(`/integrations/get_technology_partner_data/${partnerId}/${appGroupId}`, "GET", {}, { signal });
  }
);
